export default __webpack_public_path__ + "66ee99c5e76fbfaaddc306696e40a85f.png";